/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getRewardsByRewardidImage } from '../fn/loyalty/get-rewards-by-rewardid-image';
import { GetRewardsByRewardidImage$Params } from '../fn/loyalty/get-rewards-by-rewardid-image';
import { getRewardsByRewardidThumbnail } from '../fn/loyalty/get-rewards-by-rewardid-thumbnail';
import { GetRewardsByRewardidThumbnail$Params } from '../fn/loyalty/get-rewards-by-rewardid-thumbnail';
import { getRewardsCatalog } from '../fn/loyalty/get-rewards-catalog';
import { GetRewardsCatalog$Params } from '../fn/loyalty/get-rewards-catalog';
import { GetRewardsCatalogResult } from '../models/get-rewards-catalog-result';
import { getUserLoyaltyEvents } from '../fn/loyalty/get-user-loyalty-events';
import { GetUserLoyaltyEvents$Params } from '../fn/loyalty/get-user-loyalty-events';
import { GetUserLoyaltyEventsResult } from '../models/get-user-loyalty-events-result';
import { getUserPoints } from '../fn/loyalty/get-user-points';
import { GetUserPoints$Params } from '../fn/loyalty/get-user-points';
import { GetUserPointsResult } from '../models/get-user-points-result';
import { getUserRewards } from '../fn/loyalty/get-user-rewards';
import { GetUserRewards$Params } from '../fn/loyalty/get-user-rewards';
import { GetUserRewardsResult } from '../models/get-user-rewards-result';
import { postActivateReward } from '../fn/loyalty/post-activate-reward';
import { PostActivateReward$Params } from '../fn/loyalty/post-activate-reward';
import { postRedeemReward } from '../fn/loyalty/post-redeem-reward';
import { PostRedeemReward$Params } from '../fn/loyalty/post-redeem-reward';
import { postToggleLoyalty } from '../fn/loyalty/post-toggle-loyalty';
import { PostToggleLoyalty$Params } from '../fn/loyalty/post-toggle-loyalty';
import { RedeemRewardResult } from '../models/redeem-reward-result';
import { ToggleUserLoyaltyResult } from '../models/toggle-user-loyalty-result';
import { UserRewardDto } from '../models/user-reward-dto';

@Injectable({ providedIn: 'root' })
export class ApiLoyaltyService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postLoyaltyActivateReward()` */
  static readonly PostLoyaltyActivateRewardPath = '/Loyalty/activate-reward';

  /**
   * post-loyalty-activate-reward.
   *
   * Active une récompense pour l'utilisateur
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postActivateReward()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postActivateReward$Response(params?: PostActivateReward$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRewardDto>> {
    return postActivateReward(this.http, this.rootUrl, params, context);
  }

  /**
   * post-loyalty-activate-reward.
   *
   * Active une récompense pour l'utilisateur
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postActivateReward$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postActivateReward(params?: PostActivateReward$Params, context?: HttpContext): Observable<UserRewardDto> {
    return this.postActivateReward$Response(params, context).pipe(map((r: StrictHttpResponse<UserRewardDto>): UserRewardDto => r.body));
  }

  /** Path part for operation `getLoyaltyRewardsByRewardidImage()` */
  static readonly GetLoyaltyRewardsByRewardidImagePath = '/Loyalty/rewards/{RewardId}/image';

  /**
   * get-loyalty-rewards-by-rewardid-image.
   *
   * Get reward image by reward id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRewardsByRewardidImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRewardsByRewardidImage$Response(params: GetRewardsByRewardidImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getRewardsByRewardidImage(this.http, this.rootUrl, params, context);
  }

  /**
   * get-loyalty-rewards-by-rewardid-image.
   *
   * Get reward image by reward id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRewardsByRewardidImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRewardsByRewardidImage(params: GetRewardsByRewardidImage$Params, context?: HttpContext): Observable<void> {
    return this.getRewardsByRewardidImage$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `getLoyaltyRewardsCatalog()` */
  static readonly GetLoyaltyRewardsCatalogPath = '/Loyalty/rewards-catalog';

  /**
   * get-loyalty-rewards-catalog.
   *
   * Get Loyalty Rewards Catalog
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRewardsCatalog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRewardsCatalog$Response(params?: GetRewardsCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<GetRewardsCatalogResult>> {
    return getRewardsCatalog(this.http, this.rootUrl, params, context);
  }

  /**
   * get-loyalty-rewards-catalog.
   *
   * Get Loyalty Rewards Catalog
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRewardsCatalog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRewardsCatalog(params?: GetRewardsCatalog$Params, context?: HttpContext): Observable<GetRewardsCatalogResult> {
    return this.getRewardsCatalog$Response(params, context).pipe(map((r: StrictHttpResponse<GetRewardsCatalogResult>): GetRewardsCatalogResult => r.body));
  }

  /** Path part for operation `getLoyaltyRewardsByRewardidThumbnail()` */
  static readonly GetLoyaltyRewardsByRewardidThumbnailPath = '/Loyalty/rewards/{RewardId}/thumbnail';

  /**
   * get-loyalty-rewards-by-rewardid-thumbnail.
   *
   * Get reward thumbnail by reward id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRewardsByRewardidThumbnail()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRewardsByRewardidThumbnail$Response(params: GetRewardsByRewardidThumbnail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getRewardsByRewardidThumbnail(this.http, this.rootUrl, params, context);
  }

  /**
   * get-loyalty-rewards-by-rewardid-thumbnail.
   *
   * Get reward thumbnail by reward id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRewardsByRewardidThumbnail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRewardsByRewardidThumbnail(params: GetRewardsByRewardidThumbnail$Params, context?: HttpContext): Observable<void> {
    return this.getRewardsByRewardidThumbnail$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `getLoyaltyUserLoyaltyEvents()` */
  static readonly GetLoyaltyUserLoyaltyEventsPath = '/Loyalty/user-loyalty-events';

  /**
   * get-loyalty-user-loyalty-events.
   *
   * Historique d’acquisition et d’utilisation des points
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserLoyaltyEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserLoyaltyEvents$Response(params?: GetUserLoyaltyEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserLoyaltyEventsResult>> {
    return getUserLoyaltyEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * get-loyalty-user-loyalty-events.
   *
   * Historique d’acquisition et d’utilisation des points
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserLoyaltyEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserLoyaltyEvents(params?: GetUserLoyaltyEvents$Params, context?: HttpContext): Observable<GetUserLoyaltyEventsResult> {
    return this.getUserLoyaltyEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUserLoyaltyEventsResult>): GetUserLoyaltyEventsResult => r.body),
    );
  }

  /** Path part for operation `getLoyaltyUserPoints()` */
  static readonly GetLoyaltyUserPointsPath = '/Loyalty/user-points';

  /**
   * get-loyalty-user-points.
   *
   * Get User Loyalty Points
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserPoints()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserPoints$Response(params?: GetUserPoints$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserPointsResult>> {
    return getUserPoints(this.http, this.rootUrl, params, context);
  }

  /**
   * get-loyalty-user-points.
   *
   * Get User Loyalty Points
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserPoints$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserPoints(params?: GetUserPoints$Params, context?: HttpContext): Observable<GetUserPointsResult> {
    return this.getUserPoints$Response(params, context).pipe(map((r: StrictHttpResponse<GetUserPointsResult>): GetUserPointsResult => r.body));
  }

  /** Path part for operation `getLoyaltyUserRewards()` */
  static readonly GetLoyaltyUserRewardsPath = '/Loyalty/user-rewards';

  /**
   * get-loyalty-user-rewards.
   *
   * Liste des récompenses activées par l'utilisateur
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserRewards()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserRewards$Response(params?: GetUserRewards$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserRewardsResult>> {
    return getUserRewards(this.http, this.rootUrl, params, context);
  }

  /**
   * get-loyalty-user-rewards.
   *
   * Liste des récompenses activées par l'utilisateur
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserRewards$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserRewards(params?: GetUserRewards$Params, context?: HttpContext): Observable<GetUserRewardsResult> {
    return this.getUserRewards$Response(params, context).pipe(map((r: StrictHttpResponse<GetUserRewardsResult>): GetUserRewardsResult => r.body));
  }

  /** Path part for operation `postLoyaltyRedeemReward()` */
  static readonly PostLoyaltyRedeemRewardPath = '/Loyalty/redeem-reward';

  /**
   * post-loyalty-redeem-reward.
   *
   * Valide l'utilisation d'une récompense utilisateur<br>Vérifie si la récompense est valide et la marque comme utilisée
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postRedeemReward()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postRedeemReward$Response(params?: PostRedeemReward$Params, context?: HttpContext): Observable<StrictHttpResponse<RedeemRewardResult>> {
    return postRedeemReward(this.http, this.rootUrl, params, context);
  }

  /**
   * post-loyalty-redeem-reward.
   *
   * Valide l'utilisation d'une récompense utilisateur<br>Vérifie si la récompense est valide et la marque comme utilisée
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postRedeemReward$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postRedeemReward(params?: PostRedeemReward$Params, context?: HttpContext): Observable<RedeemRewardResult> {
    return this.postRedeemReward$Response(params, context).pipe(map((r: StrictHttpResponse<RedeemRewardResult>): RedeemRewardResult => r.body));
  }

  /** Path part for operation `postLoyaltyToggleLoyalty()` */
  static readonly PostLoyaltyToggleLoyaltyPath = '/Loyalty/toggle-loyalty';

  /**
   * post-loyalty-toggle-loyalty.
   *
   * Active/Désactive la fidélité du convive sur un site
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postToggleLoyalty()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postToggleLoyalty$Response(params?: PostToggleLoyalty$Params, context?: HttpContext): Observable<StrictHttpResponse<ToggleUserLoyaltyResult>> {
    return postToggleLoyalty(this.http, this.rootUrl, params, context);
  }

  /**
   * post-loyalty-toggle-loyalty.
   *
   * Active/Désactive la fidélité du convive sur un site
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postToggleLoyalty$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postToggleLoyalty(params?: PostToggleLoyalty$Params, context?: HttpContext): Observable<ToggleUserLoyaltyResult> {
    return this.postToggleLoyalty$Response(params, context).pipe(map((r: StrictHttpResponse<ToggleUserLoyaltyResult>): ToggleUserLoyaltyResult => r.body));
  }
}
